import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';

const Vacancy = () => {
  const navigate = useNavigate();
  const [vacancy, setVacancy] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const vacancyId = window.location.href.split('/').pop();
        if (vacancyId) {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/vacancies/id/${vacancyId}`);
          console.log(response.data);
          if (response.data.length > 0) {
            setVacancy(response.data[0]);
          }
        } else {
          navigate('/vacancies/list');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <PageHeader title="Job Vacancy details" description="" className="mb-3"></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : vacancy?.id ? (
        <Table hover responsive>
          <tbody>
            <tr>
              <td>Title: {vacancy.title}</td>
            </tr>
            <tr>
              <td>Enabled: {vacancy.enabled}</td>
            </tr>
            <tr>
              <td>Reference: {vacancy.reference}</td>
            </tr>
            <tr>
              <td>Date Added: {vacancy.date_added}</td>
            </tr>
            <tr>
              <td>Closing Date: {vacancy.closing_date}</td>
            </tr>
            <tr>
              <td>Contact: {vacancy.contact}</td>
            </tr>
            <tr>
              <td>Email: {vacancy.email}</td>
            </tr>
            <tr>
              <td>Tel: {vacancy.tel}</td>
            </tr>
            <tr>
              <td>
                Attachment:{' '}
                <a href={vacancy.download_file} target="_blank" rel="noreferrer">
                  Open PDF
                </a>
              </td>
            </tr>
            <tr>
              <td>Content: {vacancy.content}</td>
            </tr>
          </tbody>
        </Table>
      ) : (
        <div>Job Vacancy not found</div>
      )}
    </>
  );
};

export default Vacancy;
